import React from 'react';
import { Box } from '@material-ui/core';
import { OptionProps } from './types';
import { CategoryMarker } from './style';

const ChildOption = ({ color, name }: OptionProps) => (
    <Box py={1} display='flex' alignItems='center' ml={2}>
        <CategoryMarker circle color={color} />
        {name}
    </Box>
);

export default ChildOption;
